import React, { Component } from 'react'
import { Link } from 'react-router'
import mousetrap from 'mousetrap'
import onClickOutside from 'react-onclickoutside'

import classNames from './DropMenu.css'
import Icon from './Icon'

class DropMenu extends Component {
  componentDidMount () {
    mousetrap.bind('escape', this.props.closeMenu)
  }
  componentWillUnmount () {
    mousetrap.unbind('escape')
  }
  handleClickOutside = e => {
    const { open, toggle } = this.props
    if (open) {
      if (!toggle || e.target.getAttribute('data-toggle') !== toggle) {
        this.props.closeMenu()
      }
    }
  }
  render () {
    const { open, items, closeMenu, fixed, style } = this.props
    let className = open ? classNames.open : classNames.closed
    if (fixed) {
      className += ' ' + classNames.fixed
    }
    return (
      <div>
        <div
          className={open ? classNames.overlayActive : classNames.overlay}
          onClick={closeMenu}
        />
        <ul className={className} onClick={closeMenu} style={style}>
          {items.map(renderItem)}
        </ul>
      </div>
    )
  }
}

function renderItem ({ key, text, onClick, href, shouldShow, disabled, disabledMessage, extra, heading, ...props }) {
  if (typeof shouldShow !== 'undefined' && !shouldShow) {
    return null
  }
  if (heading) {
    return (
      <li key={heading} className={classNames.headingItem}>
        {heading}
      </li>
    )
  }
  const style = disabled ? { opacity: 0.5 } : {}
  if (disabled) {
    onClick = e => {
      e.stopPropagation()
      window.alert(disabledMessage)
    }
  }
  if (href) {
    return (
      <li key={key || text} className={classNames.item}>
        <Link to={disabled ? null : href} className={classNames.link} style={style} onClick={disabled ? onClick : undefined} {...props}>
          {text}
        </Link>
      </li>
    )
  }
  const linkClass = extra ? classNames.linkWithExtra : classNames.link
  return (
    <li key={key || text} className={classNames.item}>
      <button onClick={onClick} className={linkClass} style={style} {...props}>
        {text}
      </button>
      {extra &&
        <div className={classNames.extra}>
          {extra.map(item => (
            <button key={item.icon} onClick={item.onClick}>
              <Icon icon={item.icon} />
            </button>
          ))}
        </div>
      }
    </li>
  )
}

export default onClickOutside(DropMenu)



// WEBPACK FOOTER //
// ./src/components/DropMenu.js